// LD-2515
// Two low-risk signals for the tab-freeze investigation, both emitted with
// console.warn so LogRocket session replays carry them.
//
// 1. The exact Chrome build. The user agent string is reduced to 153.0.0.0,
//    which hides whether a workstation has the Chromium fix (153.0.8010.42).
// 2. Every native drag start, with the route and the element it began on.
//    This runs after initDragGuard: on the guarded routes the guard has
//    already cancelled and logged the event and stopped propagation, so this
//    listener only records the drags the guard leaves alone elsewhere.

import * as Sentry from '@sentry/vue'

const TAG = '[freeze-diag]'

export function initFreezeDiagnostics(router) {
  logBrowserBuild()

  document.addEventListener('dragstart', (event) => {
    const target = event.target instanceof Element ? event.target : null
    console.warn(`${TAG} dragstart`, {
      route: router.currentRoute.value?.name,
      tag: target?.tagName,
      classes: target?.getAttribute('class') || ''
    })
  }, { capture: true })
}

function logBrowserBuild() {
  const versions = navigator.userAgentData?.getHighEntropyValues?.(['fullVersionList'])
  if (!versions) return
  versions
    .then(({ fullVersionList }) => {
      const chrome = fullVersionList?.find(b => b.brand === 'Google Chrome' || b.brand === 'Chromium')
      if (!chrome) return
      console.warn(`${TAG} browser`, { brand: chrome.brand, version: chrome.version })
      Sentry.setTag('browser.full_version', chrome.version)
    })
    .catch(() => {})
}
